

import api from "./api";
import { EncryptionUtil } from "../utils/encryption.util";
import Cookies from "js-cookie";

export interface PaywallResponse {
  success: boolean;
  message: string;
  data: {
    paymentAttemptId: string;
    orderId: string;
    chargeId: string;
    paywallUrl: string;
    payloadJson: string;
    signature: string;
  };
}

// =======================
// SIGNUP OTP
// =======================

export const sendOTP = async (
  email: string,
  preferredLanguage = 'en'
) => {
  const encryptedEmail = EncryptionUtil.encrypt(email);

  const response = await api.post('/cAuth/send-otp', {
    email: encryptedEmail,
    purpose: 'signup',
    preferredLanguage,
  });

  return response.data;
};

// =======================
// VERIFY OTP (Signup)
// =======================

export const verifyOTP = async (formData: FormData) => {
  const response = await api.post(
    "/cAuth/verify-otp",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

// =======================
// LOGIN OTP
// =======================

export const sendLoginOtp = async (
  email: string,
  preferredLanguage = 'en'
) => {
  const response = await api.post('/cAuth/send-otp', {
    email,
    purpose: 'login',
    preferredLanguage,
  });

  return response.data;
};

// =======================
// LOGIN
// =======================

export const login = async (
  email: string,
  otp: string
) => {
  const response = await api.post("/cAuth/login", {
    email,
    otp,
  });

  return response.data;
};


export const getSubscriptionPlans = async (customerType: number) => {
  try {
    const response = await api.get(`/csubscription/plans?customerType=${customerType}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subscription plans:', error);
    throw error;
  }
};
export const getAllSubscriptionPlans = async (customerType: number) => {
  try {
    const response = await api.get(`/csubscription/allplans?customerType=${customerType}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subscription plans:', error);
    throw error;
  }
};

// Purchase subscription
export const purchaseSubscription = async (subscriptionPlanId: string) => {
  try {
    // customerId is no longer sent — backend derives it from the JWT.
    // Returns { paywallUrl, payloadJson, signature, orderId, ... }
    const response = await api.post('/csubscription/purchase', {
      subscriptionPlanId,
    });
    return response.data;
  } catch (error) {
    console.error('Error initiating purchase:', error);
    throw error;
  }
};

// =======================
// CUSTOMER LANGUAGE PREFERENCE
// =======================

export const updatePreferredLanguage = async (
  language: string
) => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Customer authentication token not found");
  }

  const response = await api.put(
    "/cAuth/language",
    { language },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

// =======================
// GET CUSTOMER PROFILE
// =======================

export const getCustomerProfile = async () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Customer authentication token not found");
  }

  const response = await api.get("/cAuth/profile", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
